import { graphql } from "gatsby"
import type { SpacingBase } from "@onestore/hel/dist/components/organisms/SectionOrg/SectionOrg.types"
import type { CustomColor } from "./customColor"
import type { UDSBackgroundColorComponent } from "./udsBackgroundColor"

export enum ContainerWidthType {
  TINY = "tiny",
  SMALL = "small",
  MEDIUM = "medium",
  DEFAULT = "default",
  FULL = "full",
}

export enum MarginType {
  SMALL = "small",
  DEFAULT = "default",
  HUGE = "huge",
  LARGE = "large",
  BIG = "big",
  STICKY = "sticky",
}

export type ContainerBorderColor = "none" | "base" | "bolder"

export type ContainerBorderRadius =
  | "none"
  | "xs"
  | "sm"
  | "md"
  | "default"
  | "container"
  | "lg"
  | "xl"
  | "2xl"
  | "full"

export type ContainerShadow = "none" | "sm" | "md" | "lg" | "xl" | "2xl"

export interface ContainerSettings {
  containerWidth?: "small" | "tiny" | "medium" | "full" | "default"
  isFullWidthOnMobile?: boolean
  negativeMarginTop?: SpacingBase
  negativeMarginBottom?: SpacingBase
  backgroundColor?: CustomColor | UDSBackgroundColorComponent
  border?: ContainerBorderColor
  borderRadius?: ContainerBorderRadius
  shadow?: ContainerShadow
}

export const query = graphql`
  fragment ContainerSettings on GraphCmsSquidex_ContainerSettingsComponent {
    containerWidth
    isFullWidthOnMobile
    negativeMarginTop
    negativeMarginBottom
    backgroundColor {
      ...CustomColor
      ...UDSBackgroundColor
    }
    border
    borderRadius
    shadow
  }
`

export const FRAGMENT_CONTAINER_SETTINGS = `
  fragment ContainerSettings on ContainerSettingsComponent {
    containerWidth
    isFullWidthOnMobile
    negativeMarginTop
    negativeMarginBottom
    backgroundColor {
      ...CustomColor
      ...UDSBackgroundColor
    }
    border
    borderRadius
    shadow
  }
`
